import type { HighFrequencyGameConfigQuery } from '#api/shared/@types/generated/backend/graphql-schema-types'

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (getIsServer() || to.fullPath === from.fullPath) return

  const control = useState(HIGH_FREQUENCY_GAME_QUERY_FETCH_QUERY_KEY)

  const setControlToCacheFirst = () => (control.value = 'cache-first')

  const setControlToCacheAndNetwork = () => (control.value = 'cache-and-network')

  const { isLoggedIn } = useAuth()
  if (!isLoggedIn.value) {
    setControlToCacheAndNetwork()
    return
  }

  const { getHighFrequencyGameIdInCorrectCase } = useHighFrequencyGamesOfLicensedTerritory()

  const licensedTerritory = useLicensedTerritory({ raw: true })
  const gameId = getHighFrequencyGameIdInCorrectCase(String(to.params.gameId))

  if (!gameId || !licensedTerritory) {
    setControlToCacheAndNetwork()
    return
  }

  try {
    const response = await useNuxtApp().$apollo.clients.default.query<HighFrequencyGameConfigQuery>(
      {
        fetchPolicy: 'cache-first',
        query: HighFrequencyGameConfigDocument,
        variables: { gameId, licensedTerritory },
      },
    )

    const config = response.data.highFrequencyGameConfig

    if (isGraphqlFailure(config)) {
      setControlToCacheAndNetwork()
      return
    }

    if (config.disclaimerAccepted) {
      setControlToCacheFirst()
      return
    }

    /*
     * As long as the disclaimer is not accepted,
     * we want to make sure to always fetch the latest config when entering the game.
     * The discalaimer could change after checkout, login.
     */
    setControlToCacheAndNetwork()
  } catch {
    setControlToCacheAndNetwork()
    return
  }
})
